import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { getToken } from './auth';

let echoInstance = null;

export function initEcho() {
  const token = getToken();

  // só inicializa uma vez e apenas com token
  if (!token || echoInstance) return;

  const host = process.env.REACT_APP_API_HUB;
  const { host: onlyHost } = new URL(host);
  const isHttps = window.location.protocol === 'https:';
  const portaReverb = process.env.REACT_APP_REVERB_PORT;

  window.Pusher = Pusher;
  echoInstance = new Echo({
    broadcaster: 'pusher',
    cluster: 'mt1',
    wsHost: onlyHost,
    wsPort: portaReverb,
    wssPort: portaReverb,
    encrypted: true,
    disableStats: true,
    forceTLS: isHttps,
    enabledTransports: ['wss', 'ws'],
    key: process.env.REACT_APP_REVERB_PUBLIC_KEY,
    authEndpoint: `${host}/notificacoes/v1/broadcasting/auth`,
    auth: {
      headers: { Authorization: `Bearer ${token}` }
    }
  });
}

export function getEcho() {
  return echoInstance;
}
